// export const API = "https://api-client.monitoring.web.id/";
// export const ASSETS_URL = "https://administrator.monitoring.web.id/assets/";
export const API = "https://api-client.medmon.cloud/";
export const ASSETS_URL = "https://administrator.medmon.cloud/assets/";
export const CLIENT = 40;
export const MEDIA_TYPE = ['Online', 'TV', 'Cetak', 'Radio'];
export const TONE = ['Negatif', 'Netral', 'Positif', 'Internal'];